import { Component, OnInit } from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {faPlus, faTrash, faSave, faCalendar} from '@fortawesome/free-solid-svg-icons';
import {empty} from '../../../functions';
import {catchError} from 'rxjs/operators';
import {alertMessages, AlertService} from '../../../shared/services/alert.service';
import {ExperiencedayService, experiencedayStatuses} from '../../../shared/services/experienceday.service';
import {Observable, of} from 'rxjs';
import {LocaleService} from '../../../shared/services/locale.service';
import { ClassicEditor, EditorConfig } from 'ckeditor5';

@Component({
    selector: 'app-modal-company-profile-challengeday-dates',
    templateUrl: './modal-company-profile-experienceday.component.html',
    styleUrls: ['./modal-company-profile-experienceday.component.scss'],
    standalone: false
})
export class ModalCompanyProfileExperiencedayComponent implements OnInit {

  // Icons
  faPlus = faPlus;
  faTrash = faTrash;
  faSave = faSave;
  faCalendar = faCalendar;

  public Editor = ClassicEditor;
  public editorConfig: EditorConfig = {
    removePlugins: ['Title', 'Image', 'LinkImage', 'ImageInsert', 'ImageUpload'],
    language: this.locale.getCurrentLanguage(),
    toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote'],
    heading: {
      options: [
        { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
        { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
        { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
        { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
        { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' },
        { model: 'heading5', view: 'h5', title: 'Heading 5', class: 'ck-heading_heading5' },
        { model: 'heading6', view: 'h6', title: 'Heading 6', class: 'ck-heading_heading6' }
      ]
    }
  };

  public data:any;

  public date = '';
  public dates: any = [];

  statusOptions = this.experiencedayService.getStatusOptions();

  public entity = {
    id: '',
    status: '',
    companyId: '',
    title: '',
    description: '',
    minStudents: 0,
    maxStudents: 0,
    possibleDates: <string[]> []
  }

  /**
   * Constructor
   *
   * @param activeModal
   * @param locale
   * @param experiencedayService
   * @param alertService
   */
  constructor(public activeModal: NgbActiveModal,
              private locale: LocaleService,
              private experiencedayService: ExperiencedayService,
              private alertService: AlertService) { }

  ngOnInit(): void {

    this.entity = Object.assign(this.entity, this.data.entity);

    // Set some default values for new instance
    if (empty(this.entity.id)) {
      this.entity.status = experiencedayStatuses.Concept;
    }

  }

  /**
   * Add a new date
   */
  addDate() {

    if (!this.date) return;
    if (this.entity.possibleDates.indexOf(this.date) !== -1) return;
    if (this.entity.possibleDates.indexOf(this.date.replace('00.000Z', '00Z')) !== -1) return; // extra format check

    this.entity.possibleDates.push(this.date);

  }

  /**
   * Delete a date
   * @param date
   */
  deleteDate(date:any) {

    if (this.entity.possibleDates.length == 0) return;

    this.entity.possibleDates.splice(this.entity.possibleDates.indexOf(date), 1);

  }

  /**
   * Save
   *
   * @constructor
   */
  Save() {

    // Update
    if (!empty(this.entity.id)) {

      this.experiencedayService.apiUpdateCompanyExperienceday(this.entity.companyId, this.entity.id, this.entity).pipe(catchError(this.handleError('apiUpdateCompanyExperienceday', false))).subscribe( (result:any) => {

        if (result !== false) {
          this.alertService.success(alertMessages.successDataSaved);
          this.activeModal.close(true);
        }

      });

    }
    // Create
    else {

      const { id, ...body } = this.entity;
      this.experiencedayService.apiCreateCompanyExperienceday(this.entity.companyId, body).pipe(catchError(this.handleError('apiCreateCompanyExperienceday', false))).subscribe( (result:any) => {

        if (result !== false) {
          this.alertService.success(alertMessages.successDataSaved);
          this.activeModal.close(true);
        }

      });
    }

  }

  /**
   * Error handler
   *
   * @param operation
   * @param result
   */
  handleError<T>(operation:string = '', result?: T) {
    return (error: any): Observable<T> => {

      // Handle given operation
      switch (operation) {

        case 'apiCreateCompanyExperienceday':
          // Do not perform any action, profile could be non-existing
          break;

        default:
          this.alertService.errorWithReport(error, `companyExperienceDay:${operation}`);
          break;

      }

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

}
